<template>
    <website-page no-sub-menu>

        <home-navigation/>

        <div class="main-section overlay">
            <b-container class="position-relative">
                <h4 class="mb-4 mb-lg-5" v-tr>Experts in Proximity Marketing and Technology|Experts en marketing de proximité et technologie</h4>
                <h1 class="blured" v-tr>Digital Signage, Restaurant Menuboards, Self-Ordering, Guest WiFi|Affichage et Menus Numériques, Commande Autonome, WiFi Public</h1>
                <h2 class="subtitle blured mt-4 mt-lg-5" v-tr>
                    Our SaaS solutions manages 100% of digital experiences!|
                    Nos solutions SaaS gèrent 100% des expériences numériques!
                </h2>
                <b-row>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <e-img src="img/clients-white/oreal_canada.png" alt="Client Digital Signage Oreal Canada"></e-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <e-img src="img/clients-white/mc_donald.png" alt="Client Digital Signage Restaurant McDonald"></e-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <e-img src="img/clients-white/desjardins.png" alt="Client WiFi Shopping Mall Desjardins"></e-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <e-img src="img/clients-white/transdev.png" alt="Client WiFi Bus Transports Transdev"></e-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <e-img src="img/clients-white/mty.png" alt="Client Digital Signage & Guest WiFi MTY Thai Express"></e-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <e-img src="img/clients-white/client-place-des-arts.png" alt="Client Guest & Social WiFi Place des Arts"></e-img>
                    </b-col>
                </b-row>

                <div class="mt-5">
                    <b-btn v-scroll-to="'#contact-us'" class="mr-2" variant="primary"><span v-tr>Contact Us|Contactez-nous</span></b-btn>
                    <b-btn v-if="!isMobileLayout" v-scroll-to="'#digital-signage'" variant="outline-light"><span v-tr>Learn More|En savoir plus</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

<!--        <div id="digital-signage" class="page text-center inverted">-->
<!--            <b-container>-->
<!--                <b-row>-->
<!--                    <feature-card :to="'/digital-signage|/affichage-numerique'|tr" icon="fal fa-tv">-->
<!--                        <h4 v-tr>Digital Signage|Affichage numérique</h4>-->
<!--                        <p v-tr>-->
<!--                            A complete solution for Menu Boards, Video Walls, 3D Holograms, Entertainment TV, Corporate Signage|-->
<!--                            Une solution complète de menu numérique, murs vidéo, hologrammes 3D, télévision de divertissement, et communication d'entreprise-->
<!--                        </p>-->
<!--                    </feature-card>-->
<!--                    <feature-card to="/digital-signage-holograms" icon="fal fa-atom">-->
<!--                        <h4 v-tr>3D Holograms|Hologrammes 3D</h4>-->
<!--                        <p v-tr>-->
<!--                            Impress your Customers and Visitors with our incredibly realistic 3D holographic visuals|-->
<!--                            Impressionnez vos clients et visiteurs avec des visuels holographiques 3D incroyablement réalistes-->
<!--                        </p>-->
<!--                    </feature-card>-->
<!--                    <feature-card :to="'/wifi/guest-social-wifi|/wifi-public/wifi-public-et-social'|tr" icon="fal fa-wifi">-->
<!--                        <h4 v-tr>Social & Guest WiFi|WiFi public</h4>-->
<!--                        <p v-tr>-->
<!--                            A complete solution for Managed Wi-Fi, Guest and Social WiFi, Analytics, Customer Journey|-->
<!--                            Une solution complète de WiFi public et social avec Analytique et Parcours Client-->
<!--                        </p>-->
<!--                    </feature-card>-->
<!--                </b-row>-->
<!--                &lt;!&ndash;                <b-btn v-if="!isMobileLayout" class="mt-5" v-scroll-to="'#digital-signage-store'" variant="outline-light"><span v-tr>Online Store|Acheter en ligne</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>&ndash;&gt;-->
<!--            </b-container>-->
<!--        </div>-->

        <div id="digital-signage-store" class="page text-center">
            <h3 v-tr>
                Buy Digital Signage Online|Magasiner affichage numérique
            </h3>
<!--            <h4 class="my-4" v-tr>-->
<!--                Buy Equipment and Software through our Online Store|-->
<!--                Acheter votre équipement et logiciels sur notre magasin en ligne-->
<!--            </h4>-->
            <b-container>

                <e-square-items>
                    <e-square-card href="https://www.digitalsignage.expert/shop/digital-signage-commercial-display/10?utm_source=eye_in_website&utm_medium=referral&utm_campaign=corpo_website&utm_content=buy_card_home"
                                   :img-src="require('../assets/img/store/product-commercial-tv.jpg')">
                        <h4 class="text-center" v-tr>Commercial Grade TVs|Écrans qualité commercial</h4>
                    </e-square-card>
                    <e-square-card href="https://www.digitalsignage.expert/shop/digital-signage-touch-displays/11?utm_source=eye_in_website&utm_medium=referral&utm_campaign=corpo_website&utm_content=buy_card_home"
                                   :img-src="require('../assets/img/store/product-touch-screen-tv.jpg')">
                        <h4 class="text-center" v-tr>Touch-Screen Commercial Grade|Écrans tactiles qualité commercial</h4>
                    </e-square-card>
                    <e-square-card href="https://www.digitalsignage.expert/shop/interactive-kiosks/15?utm_source=eye_in_website&utm_medium=referral&utm_campaign=corpo_website&utm_content=buy_card_home"
                                   :img-src="require('../assets/img/store/product-kiosk.jpg')">
                        <h4 class="text-center" v-tr>Interactive Kiosk|Kiosque interactif</h4>
                    </e-square-card>
                    <e-square-card href="https://www.digitalsignage.expert/shop/cloud-software-licenses/12?utm_source=eye_in_website&utm_medium=referral&utm_campaign=corpo_website&utm_content=buy_card_home"
                                   :img-src="require('../assets/img/store/product-digital-signage-license.jpg')">
                        <h4 class="text-center" v-tr>Software Licenses|Licences logiciel</h4>
                    </e-square-card>
                    <e-square-card href="https://www.digitalsignage.expert/shop/digital-signage-packages/3?utm_source=eye_in_website&utm_medium=referral&utm_campaign=corpo_website&utm_content=buy_card_home"
                                   :img-src="require('../assets/img/store/product-packages.jpg')">
                        <h4 class="text-center" v-tr>All Included Package|Packages complet</h4>
                    </e-square-card>
                    <e-square-card href="https://www.digitalsignage.expert/shop/services/14?utm_source=eye_in_website&utm_medium=referral&utm_campaign=corpo_website&utm_content=buy_card_home"
                                   :img-src="require('../assets/img/store/service-custom-design.jpg')">
                        <h4 class="text-center" v-tr>Content Creation & Services|Création de contenu & Services</h4>
                    </e-square-card>
                </e-square-items>

                <b-btn v-if="!isMobileLayout" class="mt-5" v-scroll-to="'#digital-signage'" variant="light"><span v-tr>Reliable Digital Signage|Affichage numérique simple et fiable</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
            </b-container>
        </div>

        <div id="digital-signage" class="page text-center inverted">
            <h3 v-tr>
                Simple and Reliable Digital Signage|L'affichage numérique simple et fiable
            </h3>
            <h4 class="my-4" v-tr>
                A complete solution for Menu Boards, Video Walls, 3D Holograms, Entertainment TV, Corporate Signage|
                Une solution complète de menu numérique, murs vidéo, hologrammes 3D, télévision de divertissement, et communication d'entreprise
            </h4>
            <b-container>
                <b-row>
                    <feature-card src="img/examples/videowall-oreal.jpg" square rounded :to="'/digital-signage/videowalls|/affichage-numerique/mur-ecrans-video'|tr" alt="Videowall for Corporate Signage">
                        <h4 class="mt-3" v-tr>Video Walls & Corporate Signage|Murs vidéo intelligent</h4>
                        <p v-tr>
                            Cutting Edge Digital Signage Solutions for Businesses|
                            Solutions d'affichage numérique de pointe pour les entreprises
                        </p>
                        <router-link :to="'/digital-signage/videowalls|/affichage-numerique/mur-ecrans-video'|tr" variant="primary"><span v-tr>More about Corporate Signage|Découvrir l'affichage corporatif</span> <i class="fal fa-chevron-right ml-1"></i></router-link>
                    </feature-card>

                    <feature-card src="img/examples/kiosk-inventory-shopping-mall.jpg" square rounded :to="'/digital-signage/interactive-touch-kiosk|/affichage-numerique/kiosk-tactile-interactif'|tr" alt="Interactive Touch Screen Kiosks">
                        <h4 class="mt-3" v-tr>Interactive Wayfinding Kiosk|Kiosque interactifs de navigation intelligents</h4>
                        <p v-tr>
                            Much More than a Map|Bien plus qu'un plan interactif
                        </p>
                        <router-link :to="'/digital-signage/interactive-touch-kiosk|/affichage-numerique/kiosk-tactile-interactif'|tr" variant="primary"><span v-tr>More about Interactive Kiosks|Plus sur les kiosques interactifs</span> <i class="fal fa-chevron-right ml-1"></i></router-link>
                    </feature-card>

                    <feature-card src="img/examples/holograms.jpg" square rounded :to="'/digital-signage/holograms|/affichage-numerique/hologrammes'|tr">
                        <h4 class="mt-3" v-tr>3D Holograms|Hologrammes 3D</h4>
                        <p v-tr>
                            Display incredibly realistic 3D holographic visuals|
                            Affichez des visuels holographiques 3D incroyablement réalistes
                        </p>
                        <router-link :to="'/digital-signage/holograms|/affichage-numerique/hologrammes'|tr" variant="primary"><span v-tr>More about 3D Holograms|Découvrir les hologrammes 3D</span> <i class="fal fa-chevron-right ml-1"></i></router-link>
                    </feature-card>
                </b-row>
                <b-btn v-if="!isMobileLayout" class="mt-5" v-scroll-to="'#digital-signage-for-restaurants'" variant="outline-light"><span v-tr>Digital Signage for Restaurants|Affichage numériques pour restaurants</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
            </b-container>
        </div>

        <div id="digital-signage-for-restaurants" class="page">
            <b-container class="text-center" :class="isMobileLayout ? 'text-center': ''">
                <h2 class="mb-5" v-tr>Digital Menuboard and Digital Signage for Restaurants|Affichage et menus numériques pour restaurants</h2>
                <b-row>
                    <b-col cols="12" md="4">
                        <e-img fluid fluid-grow src="img/screenshots/menuboard-cho-express.png" alt="Example Menuboard Fast Food Restaurant"/>
                        <h3 class="small mt-3" v-tr>Digital Menuboards|Menus numérique</h3>
                        <p v-tr>
                            Manage your menu in one place and display on your Digital Menuboard.|
                            La gestion des menus est entièrement centralisé : gestion des prix, de l’inventaire des éléments du menu et des images.

                        </p>
                        <p v-tr>
                            TheFoodForce comes with a simple menuboard designer module that allows you to create engaging digital menus dynamically linked to your menu items.|
                            Le diffuseur ajuste automatiquement le contenu du menu en fonction du restaurant auquel il est assigné.
                        </p>
                    </b-col>
                    <b-col cols="12" md="4">
                        <e-img fluid fluid-grow src="img/screenshots/starbucks-status-panel.png" alt="Example Digital Order Status Panel"/>
                        <h3 class="small mt-3" v-tr>Order Status Panel|Panneau de suivi des commandes</h3>
                        <p v-tr>
                            Always dreamed of showing the status of your orders on a screen like at McDonald’s?|
                            Le panneau de suivi des commandes « à la McDonalds » est une fonctionnalité restée longtemps réservées aux plus grosses chaînes de restauration.
                        </p>
                        <p v-tr>
                            Our digital signage comes with an integrated module that you can customize which pushes real-time order status to your screens.|
                            Avec notre solution d’affichage, l’intégration se fait en quelques clics et offre plusieurs options pour ajuster le style visuel à la bannière.
                        </p>
                    </b-col>
                    <b-col cols="12" md="4">
                        <e-img fluid fluid-grow src="img/screenshots/romanceboard-mccafe.png" alt="Example McCafé Advertising Board"/>
                        <h3 class="small mt-3" v-tr>Advertising Display|Affichage publicitaire</h3>
                        <p v-tr>
                            The main purpose of digital signage is to display informational or advertising content.|
                            Le but principal de l’affichage numérique est d’afficher du contenu informatif ou publicitaire.
                        </p>
                        <p v-tr>
                            Our digital signage solution allows you to manage and broadcast advertisements scheduled in advance according to the establishment, the time of day with frequency management etc ...|
                            Notre solution d’affichage permet de gérer et diffuser des publicités programmées à l’avance en fonction de l’établissement, l’heure de la journée avec gestion de la fréquence etc…
                        </p>
                    </b-col>
                </b-row>
                <br>
                <b-btn class="mt-3" :to="'/digital-signage/menuboards|/affichage-numerique/menus-restaurants'|tr" variant="primary"><span v-tr>Discover Digital Menu Boards|Découvrir les menus numériques</span> <i class="fal fa-chevron-right ml-1"></i></b-btn>

                <div v-if="!isMobileLayout" class="mt-5 text-center">
                    <b-btn v-scroll-to="'#guest-wifi'" variant="light"><span v-tr>Guest and Social WiFi|WiFi Public et Social</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="guest-wifi" class="page inverted text-center">
            <h3 v-tr>
                Discover the power of Guest WiFi|Découvrez la puissance du WiFi public social
            </h3>
            <h4 class="my-4" v-tr>
                Are you looking to deploy or enhance a WiFi solution? Look no further.|
                Vous souhaitez déployer ou améliorer une solution WiFi? Ne cherchez pas plus loin.
            </h4>
            <b-container>
                <b-row>
                    <feature-card src="img/examples/guest-wifi.jpg" square rounded :to="'/wifi/guest-social-wifi|/wifi-public/wifi-public-et-social'|tr" alt="Wifi Proximity Marketing Solutions">
                        <h4 class="mt-3" v-tr>Location Based Solutions|Solutions de marketing de proximité</h4>
                        <p v-tr>
                            Branded login pages and valuable customers insights|
                            Offrez des pages de connexion avec votre image de marque et obtenez des données importantes sur vos clients
                        </p>
                        <router-link :to="'/wifi/guest-social-wifi|/wifi-public/wifi-public-et-social'|tr" variant="primary"><span v-tr>More about Proximity Marketing|Marketing de proximité</span> <i class="fal fa-chevron-right ml-1"></i></router-link>
                    </feature-card>

                    <feature-card src="img/examples/wifi-shopping-mall.jpg" square rounded :to="'/wifi/retail-shopping-mall|/wifi-public/commerces-et-centres-commerciaux'|tr" alt="Digital Solutions for Shopping Malls" >
                        <h4 class="mt-3" v-tr>Solutions for Shopping Malls|Solution pour centres commerciaux</h4>
                        <p v-tr>
                            Understand foot traffic, visitors, frequency of visits and dwelling time.|
                            Ayez plus de visibilité sur les habitudes et comportements de votre trafic
                        </p>
                        <router-link :to="'/wifi/retail-shopping-mall|/wifi-public/commerces-et-centres-commerciaux'|tr" variant="primary"><span v-tr>Shopping Malls Solutions|Solutions pour centre commerciaux</span> <i class="fal fa-chevron-right ml-1"></i></router-link>
                    </feature-card>

                    <feature-card src="img/examples/bus-transports.jpg" square rounded :to="'/wifi-on-board/coaches-and-bus|/wifi-a-bord/bus-et-navettes'|tr" alt="WiFi Solutions for Bus">
                        <h4 class="mt-3" v-tr>Solutions for Buses|Solutions pour bus</h4>
                        <p v-tr>
                            Provide passengers with connectivity while promoting, engaging and geolocating|
                            Offrez la connectivité et interagissez avec vos passagers tout en faisant de la promotion et de la géolocalisation
                        </p>
                        <router-link :to="'/wifi-on-board/coaches-and-bus|/wifi-a-bord/bus-et-navettes'|tr" variant="primary"><span v-tr>Solutions for Buses|Solutions pour bus</span> <i class="fal fa-chevron-right ml-1"></i></router-link>
                    </feature-card>

<!--                    <b-col cols="12" md="4">-->
<!--                        <e-img rounded fluid src="img/examples/guest-wifi.jpg" alt="Wifi Proximity Marketing Solutions"/>-->
<!--                        <h4 class="mt-3" v-tr>Location Based Solutions|Solutions de marketing de proximité</h4>-->
<!--                        <p v-tr>-->
<!--                            Branded login pages and valuable customers insights|-->
<!--                            Offrez des pages de connexion avec votre image de marque et obtenez des données importantes sur vos clients-->
<!--                        </p>-->
<!--                        <router-link :to="'/wifi/guest-social-wifi|/wifi-public/wifi-public-et-social'|tr" variant="primary"><span v-tr>More about Proximity Marketing|Marketing de proximité</span> <i class="fal fa-chevron-right ml-1"></i></router-link>-->
<!--                    </b-col>-->
<!--                    <b-col cols="12" md="4">-->
<!--                        <e-img rounded fluid src="img/examples/wifi-shopping-mall.jpg" alt="Digital Solutions for Shopping Malls" />-->
<!--                        <h4 class="mt-3" v-tr>Solutions for Shopping Malls|Solution pour centres commerciaux</h4>-->
<!--                        <p v-tr>-->
<!--                            Understand foot traffic, visitors, frequency of visits and dwelling time.|-->
<!--                            Ayez plus de visibilité sur les habitudes et comportements de votre trafic-->
<!--                        </p>-->
<!--                        <router-link :to="'/wifi/retail-shopping-mall|/wifi-public/commerces-et-centres-commerciaux'|tr" variant="primary"><span v-tr>Shopping Malls Solutions|Solutions pour centre commerciaux</span> <i class="fal fa-chevron-right ml-1"></i></router-link>-->
<!--                    </b-col>-->
<!--                    <b-col cols="12" md="4">-->
<!--                        <e-img rounded fluid src="img/examples/bus-transports.jpg" alt="WiFi Solutions for Bus"/>-->
<!--                        <h4 class="mt-3" v-tr>Solutions for Buses|Solutions pour bus</h4>-->
<!--                        <p v-tr>-->
<!--                            Provide passengers with connectivity while promoting, engaging and geolocating|-->
<!--                            Offrez la connectivité et interagissez avec vos passagers tout en faisant de la promotion et de la géolocalisation-->
<!--                        </p>-->
<!--                        <router-link :to="'/wifi-on-board/coaches-and-bus|/wifi-a-bord/bus-et-navettes'|tr" variant="primary"><span v-tr>Solutions for Buses|Solutions pour bus</span> <i class="fal fa-chevron-right ml-1"></i></router-link>-->
<!--                    </b-col>-->
                </b-row>
<!--                <b-btn v-if="!isMobileLayout" class="mt-5" v-scroll-to="'#ebook'" variant="outline-light"><span v-tr>Best practice for Shopping Malls|Meilleurs pratiques pour votre centre commercial</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>-->
            </b-container>
        </div>

        <div id="ebook" class="page p-0" v-if="false">
            <e-download-form name="Best Practices for Reopening During Covid-19"
                             :cover="require('../assets/img/ebook/ebook-shopping-mall-cover.webp')"
                             :background="require('../assets/img/ebook/ebook-shopping-mall-bg.webp')"
                             href="https://eyeinlivestorage.blob.core.windows.net/public/open-door/ebook-shopping-mall.pdf">
                <div style="margin-top: 75px">
                    <h3 class="text" v-tr>
                        Best practices for the future of a Shopping Mall|
                        Les meilleurs pratiques pour le future de votre centre commercial
                    </h3>
                    <p class="text-justify f-theme" v-tr>
                        Do you have what it takes to come out of this crisis stronger than ever? Are you ready to reinvent your mall and take bold steps?|
                        Avez-vous ce qu'il faut pour ressortir de cette crise plus fort qu'avant? Êtes-vous prêt à réinventer votre centre commercial et à prendre des mesures audacieuses?
                    </p>
                    <p class="text-justify f-theme" v-tr>
                        If yes, this guide will give you out of the box solutions to remodel your initiatives with your tenants,
                        your shoppers and your industry. The status quo is riskier than trying something new. It is time to reinvent the retail industry!|
                        Si oui, ce guide vous proposera des solutions prêtes à l'emploi pour transformer vos initiatives avec vos locataires,
                        vos acheteurs et votre industrie. Le statu quo est plus risqué que d'essayer quelque chose de nouveau. Il est temps de réinventer le commerce de détail!
                    </p>
                </div>

                <template #button>
                    <span v-tr>Download E-book|Télécharger le E-book</span>
                </template>
            </e-download-form>
        </div>
    </website-page>
</template>

<script>
    import ESquareCard from "../../vue-components/components/square/e-square-card.vue";
    import ESquareItems from "../../vue-components/components/square/e-square-items.vue";
    import {isFrench} from "../../vue-components/helpers/i18n.js";
    import HomeNavigation from "../navigation/home-navigation.vue";

    export default {
        name: `home`,
        components: {HomeNavigation, ESquareCard, ESquareItems},
        data() {
            return {
                isFrench: isFrench
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main-section {
        background-color: #151e28;
        background-image: url('../assets/img/backgrounds/planet-earth.jpg');
        background-image: url('../assets/img/backgrounds/planet-earth.webp');
        background-position: center center;
        background-size: cover;
    }
</style>
